/*
 * Functions for navbar
 * Copied and modified from: static_src/js/c2/navbar.js
 * Template: templates/v5/common/navbar/navbar.html
 * 
 * These functions are needed to:
 *   1) Set 'active' class to link
 *   2) Support custom ArrowLeft, ArrowRight, ArrowDown keyboard shortcuts
 *   3) Support for bookmarks.js and search.js
 */

(function (__module__) {
  'use strict';

  var logger = c3.logging.getLogger(__module__);

  function init() {
    var $navbar = $('#top-navbar');
    activeLogoLink($navbar);
    highlightActiveSection($navbar);
    handleNavbarKeydown($navbar);

    //initialize submenus for keyboard shortcut support when opened on click
    $navbar.children().children('li.nav-item.dropdown').each(function() {
      setupKeyNavigationOfMenu($(this), $(this).find('ul.dropdown-menu'))
    });
  }

  /* get body data-topnav */
  function getBodyDataTopNav() {
    var adminChildPagesDataTopNav = [
      'admin-index',
      'actions',
      'connectioninfo',
      'customfields', //Parameters
      'environments',
      'History',
      'ipams',
      'vaults',
      'itsms',
      'jobs',
      'loadbalancers',
      'managerates',
      'network_virtualization',
      'orchestrationengines',
      'os-builds',
      'params',
      'portals',
      'preconfigurations',
      'providers',
      'resourcehandlers',
      'siem',
      'Single Sign-On'
    ];
    var $body = $('body');
    var topnav = $.trim($body.data('topnav'));

    // Some Admin child pages (stored in adminChildPagesDataTopNav) do not have the data-topnav="admin"
    // In order for the nav to activate the Admin link correctly, return "admin".
    if (adminChildPagesDataTopNav.indexOf(topnav) != -1) {
      topnav = 'admin';
    }
    return topnav;
  }

  /*
   * set or remove .active on Top Menu Bar Logo link based on page
   * Do not double activate an existing Nav Link + Logo (defined in navLinks)
   *   navLinks are auto-generated to account for links that may show/hide based on settings
   */
  function activeLogoLink($navbar) {
    var $logoLink = $('a[data-test="logo-link"]');
    var href = window.location.href;
    // Remove 'active' class if URL does not match Default Redirect
    if (href !== $logoLink[0]?.href) {
      $logoLink.removeClass('active');
      return
    }
    // Remove 'active' class if body data-topnav='admin'
    var bodyTopNav = getBodyDataTopNav();
    if (bodyTopNav === 'admin') {
      $logoLink.removeClass('active');
      return
    }
    // Add 'active' class if URL does not match existing Top Menu Bar links
    var navLinks = [];
    var $navLinkElements = $navbar.children().children('li');
    $.each($navLinkElements, function () {
      const topnav = this.dataset?.topnav;
      if (!topnav) return;
      if (topnav === 'Content Library') {
        navLinks.push('library');
      } else {
        navLinks.push(topnav);
      }
    });
    if (!href.match(navLinks.join('|'))) {
      $logoLink.addClass('active');
    }
  }

  /*
   * set .active on nav links that are hinted with the same `data-topnav`
   * attribute that the body element is hinted with (which is set by by a
   * template by using {% block topnav %}foo{% endblock %}.
   */
  function highlightActiveSection($navbar) {
    var topnav = getBodyDataTopNav()
    var $navLink = $navbar.children().children('li[data-topnav="' + topnav + '"]');

    $navLink.addClass('active');
  }

  /* Support Arrow & Space keyboard navigation of top level menu items */
  function handleNavbarKeydown($navbar) {
    var $navbarItems = $.merge($('a[data-test="logo-link"]'), $navbar.children().children('li'));
    $navbarItems.on('keydown.nav-item', function (e) {
      var $menu = $(this),
        key = e.key,
        focusedIndex = $navbarItems.index($menu);
      logger.debug('navbar keydown:', e.key);

      // Ignore if key happened in an input or textarea (e.g search), or
      // key was already handled by another keydown handler, e.g in c3.search.
      if (e.isDefaultPrevented() || c3.commonEventHandlers.isUserTypingInField(e)) {
        return;
      }

      if (e.metaKey || e.ctrlKey) {
        logger.debug('Ignoring menu keydown modified by CMD/CTRL');
        return;
      }
      if (key === 'Tab' && e.shiftKey === true) {
        key = 'Shift+Tab';
      }
      
      switch (key) {
        case 'ArrowDown':
        case 'Down': // MS Edge
          openSubMenu($menu);
          e.preventDefault();
          break;
        case ' ':
          openSubMenu($menu, true);
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'Left': // MS Edge
        case 'Shift+Tab':
          closeAllMenus();
          if (focusedIndex > 0) {
            $navbarItems.eq(focusedIndex).children('a').blur();
            if (focusedIndex === 1) {
              //for $('a[data-test="logo-link"]')
              $navbarItems.eq(focusedIndex - 1).focus()
            } else {
              //for children('li')
              $navbarItems.eq(focusedIndex - 1).children('a').focus();
              openSubMenu($navbarItems.eq(focusedIndex - 1));
            }
            e.preventDefault();
          }
          break;
        case 'ArrowRight':
        case 'Right': // MS Edge
        case 'Tab':
          closeAllMenus();
          if (focusedIndex < $navbarItems.length) {
            focusedIndex === 0 ?
              $navbarItems.eq(focusedIndex).blur() //for $('a[data-test="logo-link"]')
              :
              $navbarItems.eq(focusedIndex).children('a').blur(); //for children('li')
            $navbarItems.eq(focusedIndex + 1).children('a').focus();
            openSubMenu($navbarItems.eq(focusedIndex + 1));
            e.preventDefault();
          }
          break;
      }
    });
  }

  /* Return if the dropdown menu is open */
  function isSubMenuOpen($topMenuItem) {
    return $topMenuItem.hasClass('show');
  }

  /* Open the dropdown-menu */
  function openSubMenu($topMenuItem, spaceKeyPressed) {
    var $subMenu = $topMenuItem.find('ul.dropdown-menu');
    if ($subMenu[0]) { // li has dropdown menu
      if (isSubMenuOpen($subMenu)) {
        return;
      }
      closeAllMenus();

      // Focus the top item's anchor so it receives keyboard events from now on
      $topMenuItem.children('a')[0].focus();
      $topMenuItem.children('a')[0].click();
      setupKeyNavigationOfMenu($topMenuItem, $subMenu);

      // Focus the first field in the submenu
      setTimeout(function () {
        $subMenu.find('a,input').first().focus();
      }, 100);

      $subMenu.find('a,input').on('hover.navbar', function (e) {
        $(this).focus();
      });
    } else {
      // If the SPACE key was pressed, will function similar to ENTER keypress
      // and take the user to the page for links without dropdown menus
      if (spaceKeyPressed) {
        if (!$topMenuItem.hasClass("active")) {
          $topMenuItem.children('a')[0].click();
        }
      }
      if ($topMenuItem.children('a')[0]) {
        $topMenuItem.children('a')[0].focus();
      } else {
        $topMenuItem[0].focus();
      }

    }
  }

  /*
   * Bind keydown handler on the submenu for key navigation of its contents.
   * This should be called if a submenu's content has changed, e.g. Search results.
   */
  function setupKeyNavigationOfMenu($topMenuItem, $subMenu) {
    $subMenu.off('keydown.nav-item');
    // Drop-down menu links should have class="dropdown-item"
    $subMenu.on('keydown.dropdown-item', function (e) {
      var $sub = $(this),
        $items = $sub.find('a,input'),
        key = e.key,
        focused = document.activeElement,
        focusedIndex = $items.index(focused);

      // Ignore if key happened in an input or textarea (e.g search), or
      // key was already handled by another keydown handler, e.g in c3.search.
      if (e.isDefaultPrevented() || c3.commonEventHandlers.isUserTypingInField(e)) {
        return;
      }

      logger.debug('  submenu keydown:', e.key);
      switch (key) {
        case ' ':
          /* TODO: [v5] update logic to close search menu
           * when pagination links are not clicked in Search Results
           * e.g !$($items[focusedIndex]).attr("data-page")
          */
          if ($topMenuItem.attr("data-topnav") !== "search") {
            closeAllMenus();
          }
          setTimeout(() => {
            c3.spinners.showSpinner({selector:'#content', block:true})
            $items[focusedIndex].click();
          },600)
          break;
        case 'ArrowRight':
        case 'Right': // MS Edge
          closeAllMenus();
          openSubMenu($topMenuItem.next('li'));
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'Left': // MS Edge
          closeAllMenus();
          openSubMenu($topMenuItem.prev('li')[0] ? $topMenuItem.prev('li') : $('a[data-test="logo-link"]'));
          e.preventDefault();
          break;
      }
    });
  }

  /* Close dropdown menus opened via keyboard shortcuts */
  function closeAllMenus() {
    if ($('#top-navbar li').find('a,ul').hasClass('show')) {
      $('#top-navbar li').find('a,ul').removeClass('show');
    }
  }

  /* Close a dropdown menu - called from bookmarks.js & search.js */
  function closeSubMenu($topMenuItem) {
    $topMenuItem.find('ul').removeClass('show');
  }

  c3[__module__] = {
    init: init,
    isSubMenuOpen: isSubMenuOpen,
    openSubMenu: openSubMenu,
    closeSubMenu: closeSubMenu,
    setupKeyNavigationOfMenu: setupKeyNavigationOfMenu
  };
})('navbar');
